"use client";

import { useSiteContext } from "@/components/providers/SiteContextProvider";
import { getTranslations } from "@/lib/i18n";

// Eén pauzeknop voor elke film op de site (Dennis 28-10-2026): de ronde knop van
// de Exclusive-dealpagina (.ex-rb), hier als eigen kopie zodat niets uit
// src/components/exclusive of luxe wordt geïmporteerd. 44x44, rand #dce5e8,
// achtergrond rgba(255,255,255,0.95) (hover wit), kleur #233944.

export default function FilmPauzeKnop({ gepauzeerd = false, onWissel, className = "", style }) {
  const { locale } = useSiteContext();
  const { t } = getTranslations(locale);
  const label = gepauzeerd ? t("hero_film.afspelen", "Film afspelen") : t("hero_film.pauze", "Film pauzeren");
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-pressed={gepauzeerd ? "true" : "false"}
      onClick={onWissel}
      style={style}
      className={`inline-flex items-center justify-center shrink-0 w-11 h-11 min-w-[44px] min-h-[44px] p-0 rounded-full border border-[#dce5e8] bg-white/95 hover:bg-white text-[#233944] cursor-pointer active:text-[#233944] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0a8de9] ${className}`.trim()}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        {gepauzeerd ? <path d="M8 5l11 7-11 7z" /> : <path d="M9 5v14M15 5v14" />}
      </svg>
    </button>
  );
}
